/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTeamMemberAvailabilityRequest} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'
import {GetTeamMemberAvailabilityResponse} from '@cash-web/protos/squareup/timecards/scheduling/availability.pb'


export const getTeamMemberAvailability = (request: GetTeamMemberAvailabilityRequest, options?: CashRequestOptions) => post<GetTeamMemberAvailabilityRequest, GetTeamMemberAvailabilityResponse>("/2.0/cash/get-team-member-availability", request, {...options, rejectOnError: true })